import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHelper } from '@umss/shared/utils';
import { Observable } from 'rxjs';
import { Notification } from '../models';
import { NotificationSearchDto } from '../models/notification/notification-search.dto';
import { PagedResultDto } from '../models/paged-result.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private readonly notificationsUrl = '/api/Notifications';

  constructor(private http: HttpClient) {}

  /**
   * Get all notifications for the current user
   */
  getNotifications(
    searchDto?: NotificationSearchDto
  ): Observable<PagedResultDto<Notification>> {
    const params = HttpHelper.toHttpParams(searchDto ?? {});

    return this.http.get<PagedResultDto<Notification>>(this.notificationsUrl, {
      params,
    });
  }

  /**
   * Get notification by ID
   */
  getNotificationById(id: string): Observable<Notification> {
    return this.http.get<Notification>(`${this.notificationsUrl}/${id}`);
  }

  /**
   * Get unread notification count
   */
  getUnreadCount(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(
      `${this.notificationsUrl}/unread-count`
    );
  }

  /**
   * Mark a notification as read
   */
  markAsRead(id: string): Observable<void> {
    return this.http.post<void>(`${this.notificationsUrl}/${id}/mark-read`, {});
  }

  /**
   * Mark all notifications as read
   */
  markAllAsRead(): Observable<void> {
    return this.http.post<void>(`${this.notificationsUrl}/mark-all-read`, {});
  }
}
